import { useMemo } from 'react'

import type { AggregatedDemographics, ReferenceFields } from 'honeygrid-types'

export const usePercentileValues = (
	field: ReferenceFields,
	aggregatedDemographics?: AggregatedDemographics
) => {
	const percentileValues = useMemo(() => {
		if (!aggregatedDemographics) {
			return [] as number[]
		}

		const sortedCellIds = aggregatedDemographics.sortedCellIds[field]

		if (!sortedCellIds) {
			return [] as number[]
		}

		const percentileIntervals = Math.round(sortedCellIds.length / 100)
		const fieldPercentileValues: number[] = Array.from({ length: 100 })

		for (const [index, _] of fieldPercentileValues.entries()) {
			const percentileIndex = Math.min(index * percentileIntervals, sortedCellIds.length - 1)
			const cellId = sortedCellIds[percentileIndex]

			if (aggregatedDemographics.cells[cellId]?.[field]) {
				fieldPercentileValues[index] = aggregatedDemographics.cells[cellId][field] as number
			} else {
				return [] as number[]
			}
		}

		return fieldPercentileValues
	}, [aggregatedDemographics, field])

	return percentileValues
}
